export default __webpack_public_path__ + "static/media/undraw_file_searching_re_3evy.dbc55328.svg";